import { Component, signal, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  AbstractDialog,
  AbstractDialogData,
  AbstractDialogResultData,
} from '@next/core-lib/dialog';
import { AgrSharedModule } from '@next/core-lib/shared';

@Component({
  selector: 'app-import-file-dialog',
  templateUrl: './import-file-dialog.component.html',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, AgrSharedModule],
})
export class ImportFileDialogComponent extends AbstractDialog<ImportFileDialogOutputModel> {
  data = inject<AbstractDialogData>(MAT_DIALOG_DATA);
  protected mdDialogRef =
    inject<
      MatDialogRef<ImportFileDialogComponent, AbstractDialogResultData<ImportFileDialogOutputModel>>
    >(MatDialogRef);

  readonly selectedFile = signal<File | null>(null);

  constructor() {
    super();
  }

  onAdmissionFileSelected(event: Event) {
    const input = event.target as HTMLInputElement | null;
    this.selectedFile.set(input?.files?.[0] ?? null);
  }

  onSubmit() {
    this.confirm({ file: this.selectedFile() });
  }
}

export interface ImportFileDialogOutputModel {
  file: File;
}
